// src/components/Modals/CallModal.jsx
import React, { useRef, useEffect, useState } from 'react';

const FloorImageContainer = ({ floor, prefix = 'CF' }) => {
  if (!floor || floor === '-') {
    return <span className="text-3xl font-light text-gray-700">-</span>;
  }

  return (
    <div className="flex justify-center items-center space-x-1">
      {floor.split('').map((char, index) => (
        <FloorCharImage
          key={`${floor}-${index}-${char}`}
          char={char}
          prefix={prefix}
        />
      ))}
    </div>
  );
};

const FloorCharImage = ({ char, prefix }) => {
  const [imageError, setImageError] = React.useState(false);

  if (imageError) {
    return <span className="text-3xl font-light text-gray-700">{char}</span>;
  }

  return (
    <img
      src={`./assets/static/${prefix}__/${prefix}_${char}.png`}
      className="h-6 w-auto"
      alt={char}
      onError={() => setImageError(true)}
    />
  );
};

const CallModal = ({ isOpen, onClose, currentFloor, destinationFloor, floors }) => {
  const textRef = useRef(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  // 内部値(floor)から表示値(frontName)を取得
  const getDisplayFloor = (floor) => {
    if (!floors || !floor || floor === '-') return floor;
    const floorData = floors.find(f => f.floor === floor);
    return floorData?.frontName || floor;
  };

  const displayCurrentFloor = getDisplayFloor(currentFloor);
  const displayDestinationFloor = getDisplayFloor(destinationFloor);

  useEffect(() => {
    if (isOpen && textRef.current) {
      // テキストが複数行かどうかを判定
      const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
      const height = textRef.current.clientHeight;
      setIsMultiLine(height > lineHeight * 1.5); // 1.5行以上なら複数行と判定
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const isValidFloor = (floor) => {
    return floor && floor !== '-' && floor !== null && floor !== undefined && floor.toString().trim() !== '';
  };

  const hasValidFloors = isValidFloor(currentFloor) && isValidFloor(destinationFloor);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xs mx-auto transform transition-all duration-300 ease-out">
        <div className="p-6 text-center relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 active:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="w-12 h-12 mx-auto mb-4 flex justify-center items-center animate-pulse">
            <img src="./assets/static/PI_CC_1.png" className="w-8 h-8 object-contain" alt="calling" />
          </div>

          {hasValidFloors ? (
            <div className="flex items-center justify-center space-x-4 text-3xl font-bold text-gray-800">
              <div className="flex justify-center items-end space-x-1">
                <FloorImageContainer floor={displayCurrentFloor} prefix="PF" />
                <img src="./assets/static/PF__/PF_F.png" className="h-4 w-auto self-end" alt="F" />
              </div>

              <img src="./assets/static/PI_CC_2.png" className="h-6 w-6 mx-4" alt="arrow" />

              <div className="flex justify-center items-end space-x-1">
                <FloorImageContainer floor={displayDestinationFloor} prefix="PF" />
                <img src="./assets/static/PF__/PF_F.png" className="h-4 w-auto self-end" alt="F" />
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-center space-x-4 text-3xl font-bold text-gray-400">
              <span>階が選択されていません</span>
            </div>
          )}

          <h3 className="text-lg font-bold text-gray-800 mt-4">エレベータを呼びました</h3>
          <p
            ref={textRef}
            className={`text-sm text-gray-600 mt-2 leading-relaxed ${isMultiLine ? 'text-left' : 'text-center'}`}
          >
            到着したエレベータにお乗りください。乗場ボタンが点灯していない場合、再度呼び出してください。
          </p>

          <button
            onClick={onClose}
            className="mt-12 w-full ux-bg-dark-gray text-white font-bold py-2 px-4 rounded-lg active:bg-gray-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallModal;